exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-de3378ca]{width:80px;display:inline-block;font-weight:bold}\n", ""]);

// exports
